import React from "react";
import "./GallerySection.css";

function GallerySection() {
  return (
    <div className="gallery-section">
      <h3 className="gallery-section__heading-main">गेलरी</h3>

      {/*  */}

      <div className="gallery-section__temp-box">
        <h3>अहिले कुनै गेलरी उपलब्द छैनन्</h3>
      </div>
    </div>
  );
}

export default GallerySection;
